<!--主要用于复杂图表-->
<template>
  <div ref="chart" class="chart" :style="{ height: height, ...chartStyle }">适用所有图表</div>
</template>

<script>
import { echartBaseMixin } from '../mixins'

export default {
  name: 'BaseChart',
  mixins: [echartBaseMixin], // 混合
  props: {
    // 配置项
    option: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'all',
    },
    yAxis: {
      type: [Object, Array],
      default: () => ({}),
    },
    grid: {
      // containLabel: true,
      type: Object,
      default: () => ({
        top: '10%',
        bottom: '18%',
        left: '5%',
        right: '5%',
      }),
    },
  },
  data() {
    return {}
  },
  watch: {
    option: {
      handler() {
        this.initOptionConfig()
        this.renderChart()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initOptionConfig() {
      const that = this
      // 基本配置
      this.options = {
        grid: this.grid,
        toolbox: this.toolbox,
        legend: this.legend,
        tooltip: this.tooltip,
        yAxis: this.yAxis,
        ...this.option,
      }
    },
  },
}
</script>
<style lang="less" scoped>
.chart {
  width: 100%;
}
</style>
